var map = {
	"./icons/activity-logs.svg": 33269,
	"./icons/admin.svg": 77363,
	"./icons/backup-now.svg": 57003,
	"./icons/calendar.svg": 46752,
	"./icons/calender-icon.svg": 93226,
	"./icons/classes.svg": 11368,
	"./icons/close-icon.svg": 84954,
	"./icons/compare.svg": 67277,
	"./icons/contacts.svg": 58417,
	"./icons/delete-icon.svg": 35109,
	"./icons/download.svg": 96179,
	"./icons/drives.svg": 47682,
	"./icons/edit.svg": 14952,
	"./icons/entra-id.svg": 38933,
	"./icons/groups.svg": 12059,
	"./icons/mail.svg": 47382,
	"./icons/overview.svg": 92306,
	"./icons/recovery-menu.svg": 76084,
	"./icons/recovery.svg": 56706,
	"./icons/refresh.svg": 80467,
	"./icons/responsive-restore-icon.svg": 31013,
	"./icons/responsive-search-icon.svg": 42698,
	"./icons/responsive-user-icon.svg": 17912,
	"./icons/search.svg": 71212,
	"./icons/seat-management.svg": 2538,
	"./icons/setting.svg": 83001,
	"./icons/user-icon.svg": 15184,
	"./icons/users.svg": 74828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34354;